import { ArrowLeftIcon } from '@rsos/assets/icons';
import { Text } from '@rsos/base-components';
import { useSelectedRequestId } from '@rsos/reduxDataStore/src/features/resourceRequests';
import AirAmbulanceForm from '../../../../AirAmbulanceForm';
import { PanelCloseButton } from './PanelCloseButton';
import {
  FormHeader,
  FormContent,
  BackButton,
} from './ResourceRequestPanel.styles';

interface AirAmbulanceViewProps {
  onBack: () => void;
}

function AirAmbulanceView({ onBack }: AirAmbulanceViewProps) {
  const selectedRequestId = useSelectedRequestId();
  const headerText = selectedRequestId
    ? 'Resource Request'
    : 'New Resource Request';

  return (
    <>
      <FormHeader>
        <BackButton
          onClick={onBack}
          data-name="resource-panel-back-button"
          aria-label="Back to resource list"
        >
          <ArrowLeftIcon color="secondaryText" height={12} width={12} />
        </BackButton>
        <div>
          <Text
            color="secondaryText"
            size="small"
            data-name="resource-panel-form-title"
          >
            {headerText}
          </Text>
        </div>
        <PanelCloseButton />
      </FormHeader>
      <FormContent>
        <AirAmbulanceForm hideBackButton noBorder />
      </FormContent>
    </>
  );
}

export default AirAmbulanceView;
